import { uuidv7 } from 'uuidv7';

/** Client-generated, time-ordered UUIDv7 so rows created offline link up correctly. */
export const newId = (): string => uuidv7();
